import React from 'react';
import { AdminPerformanceInterface } from '@/components/performance/AdminPerformanceInterface';

const BehaviorTrackingPage: React.FC = () => {
  return <AdminPerformanceInterface />;
};

export default BehaviorTrackingPage;